import React from "react";
import LazyLoad from "react-lazyload";
import Hero from "../components/Hero";
import CardSection from "../components/CardSection";
import LatestStories from "../components/LatestStories";
import UpcomingEvents from "../components/UpcomingEvents";
import ModularHousingPlan from "../components/ModularHousingPlan";
import NewsletterSignup from "../components/NewsletterSignup";
import FeatureGrid from "../components/FeatureGrid";
import SponsorCarousel from "../components/SponsorCarousel";
import MissionComponent from "../components/MissionComponent";
import AnimatedComponent from "../components/AnimatedComponent";
import { fadeInUp } from "../animations";
import tempImage from "../assets/images/temp.jpg";
import EventHighlight from "../components/EventHighlight";
import AnniversaryHighlight from "../components/AnniversaryHighlight";

const Home = () => {
  const callToActionContent = {
    backgroundImage: tempImage,
    title: "Home Starts With You",
    description:
      "Help us build a stronger Buffalo by supporting affordable housing initiatives. Your contribution can make a difference in creating more homes for families in need.",
    buttonText: "DONATE NOW",
    buttonLink: "/donate",
  };

  return (
    <>
      <Hero />
      <FeatureGrid />
      <LazyLoad
        height={200}
        offset={100}
        placeholder={<div style={{ height: "200px", background: "#f0f0f0" }} />}
      >
        {/* <AnimatedComponent animation={fadeInUp}>
          <EventHighlight />
        </AnimatedComponent> */}
      </LazyLoad>
      <AnimatedComponent animation={fadeInUp}>
        <MissionComponent />
      </AnimatedComponent>
      <AnimatedComponent animation={fadeInUp}>
        <CardSection />
      </AnimatedComponent>
      <AnimatedComponent animation={fadeInUp}>
        <NewsletterSignup />
      </AnimatedComponent>
      <LazyLoad
        height={200}
        offset={100}
        placeholder={<div style={{ height: "200px", background: "#f0f0f0" }} />}
      >
        <AnimatedComponent animation={fadeInUp}>
          <LatestStories />
        </AnimatedComponent>
      </LazyLoad>
      <LazyLoad
        height={200}
        offset={100}
        placeholder={<div style={{ height: "200px", background: "#f0f0f0" }} />}
      ></LazyLoad>

      <LazyLoad
        height={200}
        offset={100}
        placeholder={<div style={{ height: "200px", background: "#f0f0f0" }} />}
      >
        <AnimatedComponent animation={fadeInUp}>
          <UpcomingEvents />
        </AnimatedComponent>
      </LazyLoad>
      <LazyLoad
        height={200}
        offset={100}
        placeholder={<div style={{ height: "200px", background: "#f0f0f0" }} />}
      >
        <AnimatedComponent animation={fadeInUp}>
          <SponsorCarousel />
        </AnimatedComponent>
      </LazyLoad>
    </>
  );
};

export default Home;
